import { render, staticRenderFns } from "./PaginatedFooter.vue?vue&type=template&id=528f4fb5&"
import script from "./PaginatedFooter.vue?vue&type=script&lang=js&"
export * from "./PaginatedFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports